export type { PlantLayoutAreaDrawingsProps } from './plant-layout-area-drawings';
export * from './plant-layout-area-drawings.routes';

export { default as PlantLayoutAreaDrawings, default } from './plant-layout-area-drawings';
